import {Component, Input} from '@angular/core';

@Component({
  selector: 'kng-footer',
  templateUrl: './kng-footer.component.html'
})
export class KngFooterComponent {

  @Input()
  public title: string;

  constructor() { }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-footer/kng-footer.component.ts